@use "@fukuri-admins/ui/layout" as *;

.container {
  width: 100%;
  height: 100%;
  padding: 24px;
}

.emptyText {
  @include typography("Jp/16_W3");
  color: text("Low");
}